import React, { useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { makeStyles } from 'tss-react/mui';
import { Theme } from "@mui/material";
import { Button, Collapse, ListItem } from '@mui/material';

const useStyles = makeStyles<void, 'title' | 'icon'>()((theme: Theme, _params, classes) => ({
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: theme.palette.text.secondary,
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
  },
  buttonLeaf: {
    color: theme.palette.text.secondary,
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    // fontWeight: theme.typography.fontWeightMedium,
    "&.depth-0": {
      [`& .${classes.title}`]: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
  title: {
    marginRight: "auto",
  },
  active: {
    color: theme.palette.secondary.main,
    [`& .${classes.title}`]: {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.secondary.main,
    },
    [`& .${classes.icon}`]: {
      color: theme.palette.secondary.main,
    },
  },
}));

interface Props {
  title: string, 
  href?: string, 
  depth: number, 
  children?: React.ReactNode, 
  icon: any, 
  className?: string, 
  open: boolean, 
  info: any
}


function NavItem({
  title,
  href,
  depth,
  children,
  icon: Icon,
  className,
  open: openProp = false,
  info: Info,
  ...rest
}: Props) {

  const { classes, cx } = useStyles();

  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
      (<ListItem
        className={cx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className={classes.button} onClick={handleToggle} style={style}>
          {Icon && <Icon className={classes.icon} size="20" />}
          <span className={classes.title}>{title}</span>
          {open ? (
            <ExpandLessIcon className="" color="inherit" />
          ) : (
            <ExpandMoreIcon color="inherit" />
          )}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>)
    );
  }

  return (
    (<ListItem
      className={cx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={cx(classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        exact
        style={style}
        to={href}
      >
        {Icon && <Icon className={classes.icon} size="20" />}
        <span className={classes.title}>{title}</span>
        {Info && <Info className={""} />}
      </Button>
    </ListItem>)
  );
}

export default NavItem;
